import { useState, useEffect } from 'react';

export const useA11yState = (initialValue = false) => {
  const [a11yEnabled, setA11yEnabled] = useState(initialValue);

  const toggleA11y = () => {
    const newState = !a11yEnabled;
    localStorage.setItem('UsableNetAssistive', newState.toString());
    setA11yEnabled(newState);
    window.dispatchEvent(
      new CustomEvent('a11yStateChange', { detail: newState }),
    );
  };

  useEffect(() => {
    const checkA11y = () => {
      const storedA11y = localStorage.getItem('UsableNetAssistive');
      const newState = storedA11y === 'true';
      setA11yEnabled(newState);
    };

    checkA11y();

    const handleA11yChange = (event: Event) => {
      const customEvent = event as CustomEvent;
      if (customEvent.detail !== undefined) {
        setA11yEnabled(customEvent.detail);
      } else {
        checkA11y();
      }
    };

    window.addEventListener('a11yStateChange', handleA11yChange);
    window.addEventListener('storage', checkA11y);

    return () => {
      window.removeEventListener('a11yStateChange', handleA11yChange);
      window.removeEventListener('storage', checkA11y);
    };
  }, []);

  return { a11yEnabled, toggleA11y };
};
